import React, { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from './AuthProvider'
import { useConfig } from './ConfigProvider'
import { toast } from 'react-toastify'
import { SaveBasket, GetSavedBaskets, SaveBasketFromOrder } from '../Services/BasketService'

const SavedBasketsContext = createContext()

export const useSavedBaskets = () => {
    return useContext(SavedBasketsContext)
}

export const SavedBasketsProvider = ({ children }) => {
    const { authState } = useAuth()
    const { api } = useConfig()

    const [savedBaskets, setSavedBaskets] = useState([])
    const [isLoadingSavedBaskets, setIsLoadingSavedBaskets] = useState(false)

    useEffect(() => {
        handleGetSavedBasket()
    }, [api])

    const handleSaveBasket = async (basketItems, basketName) => {
        try {
            await SaveBasket(api, basketItems, authState.custId, basketName, authState.siteId, authState.whId)
            return true
        } catch (error) {
            console.log(error)
            toast.error('Nie udało się zapisać koszyka!')
            return false
        }
    }

    const handleSaveBasketFromOrder = async (basketItems, basketName) => {
        try {
            await SaveBasketFromOrder(api, basketItems, authState.custId, basketName)
            return true
        } catch (error) {
            console.log(error)
            toast.error('Nie udało się zapisać koszyka!')
            return false
        }
    }

    const handleGetSavedBasket = () => {
        setIsLoadingSavedBaskets(true)
        GetSavedBaskets(api, authState.custId, authState.siteId, authState.whId).then(res => {
            setSavedBaskets(res.data)
        }).catch(e => {
            console.log(e)
        }).finally(() => { setIsLoadingSavedBaskets(false) })
    }


    return (
        <SavedBasketsContext.Provider value={{
            handleSaveBasket,
            handleSaveBasketFromOrder,
            setIsLoadingSavedBaskets,
            handleGetSavedBasket,
            savedBaskets,
            isLoadingSavedBaskets
        }}>
            {children}
        </SavedBasketsContext.Provider>
    )
}